import React from 'react'
import Dialog from 'material-ui/Dialog'
import Loadable from 'react-loading-overlay'

export default ({ active, children }) =>
  active ? (
    <Dialog open fullScreen>
      <Loadable animate={false} background="#fff" color="#000" active spinner>
        <div style={{ width: '100vw', height: '100vh' }} />
      </Loadable>
    </Dialog>
  ) : (
    children || null
  )



// WEBPACK FOOTER //
// ./src/components/loading/index.js